import { Component } from '@angular/core';
import { IWebsiteConstants, PinterestShareData, ShareData, TwitterShareData } from '@lmnop/web-core';
import { ControlBase } from '../../base/control-base/control-base.component';
import { NgxSpinnerService } from 'ngx-spinner';

export class ShareButtonsComponentInitData {
    public url: string = '';
    public title: string = '';
    public pinterestMedia: string = '';
    public twitterHashtags: string = '';
    public twitterVia: string = '';
}

@Component({
    selector: 'share-buttons-control',
    templateUrl: 'share-buttons.control.html',
    styleUrl: './share-buttons.control.scss',
    standalone: false,
})
export class ShareButtonsControl extends ControlBase {
    constructor(protected override spinnerService: NgxSpinnerService) {
        super(spinnerService);
        this.websiteConstants = this.ioc.core.websiteConstants;
    }

    public websiteConstants: IWebsiteConstants;

    public initData: ShareButtonsComponentInitData;

    public onShareClick(type: string): void {
        let shareData: ShareData;
        switch (type) {
            case this.ioc.core.websiteConstants.pinterest.NAME:
                shareData = new PinterestShareData(
                    this.initData.url,
                    this.initData.title,
                    this.initData.pinterestMedia
                );
                break;
            case this.ioc.core.websiteConstants.twitter.NAME:
                shareData = new TwitterShareData(
                    this.initData.url,
                    this.initData.title,
                    this.initData.twitterHashtags,
                    this.initData.twitterVia
                );
                break;
            default:
                shareData = new ShareData(this.initData.url, this.initData.title);
                break;
        }

        window.open(this.websiteConstants.getShareUrl(type, shareData));
    }
}
